import React from 'react';
import ComponentErp from './ComponentErp.js';
import store from '../store';

import FormEdit from '../components/FormEdit.js';
import { GetRelatorioFornAPI } from '../models/ModelContasPagar.js';


class RelatorioContasPagarFornecedores extends ComponentErp {
  constructor(props) {
    super(props);
    this.state = store.getState().relContasPagarGeral.gridsForn;
  }

  componentDidMount() {
    this.callApi()
  }

  componentDidUpdate(prevProps, prevState) {

    if (this.state.refresh === 'gravando') {
      this.setState({ refresh: 'buscando' });
      this.callApi()
    }

  }

  handleSubmit = (event) => {
    event.preventDefault()
    var response = {
      refresh: 'gravando',
      fAno: this.state.fAno,
      id_fornecedor: this.state.id_fornecedor,
      type: 'RELCONTASPAGARFORN.TOOGLE_FBUSCA'
    }
    this.updateReduxAndState(response);

  }

  async callApi() {
    var gridsForn = store.getState().relContasPagarGeral.gridsForn;

    var response = await GetRelatorioFornAPI(gridsForn.fAno, gridsForn.id_fornecedor);
    response.refresh = 'concluido';
    response.type = 'RELCONTASPAGARFORN.TOOGLE_LISTA';

    this.updateRedux(response);
    gridsForn = store.getState().relContasPagarGeral.gridsForn;
    this.setState(gridsForn);
  }



  render() {

    return (

      <div className="container">
        <div className="row">
          <h2 className="section-title">Relatório - Despesa analítica</h2>
          <div className="card">
            {this.navMenu(store.getState().relContasPagarGeral.gridsForn.nav)}

            <div id="lista" className="dataTables_wrapper no-footer row">
              <form name="form" onSubmit={this.handleSubmit} action="" method="get" encType="multipart/form-data">

                {<FormEdit id='fAno'
                  label='Ano'
                  value={this.state.fAno}
                  onChange={this.handleInputChange}
                  typeField='number'
                  styleDiv='4' />}

                {<FormEdit id='nome_fornecedor'
                  label='Nome Fornecedor'
                  styleDiv='2'
                  typeField='autocomplete'
                  onChange={this.handleInputChangeFornecedor}
                  loadData={this.loadDataFornecedor}
                  options={[(this.state.id_fornecedor !== '') ? { id: this.state.id_fornecedor, nome: this.state.nome_fornecedor } : { id: 0, nome: '' }]}
                  value={(this.state.id_fornecedor !== '') ? { id: this.state.id_fornecedor, nome: this.state.nome_fornecedor } : { id: 0, nome: '' }}
                  required='on'
                />}

                {<FormEdit id='submit'
                  label='Pesquisar'
                  styleDiv='submit'
                  styleField='submit'
                  typeField='submit'
                  icon='pesquisa'
                />}

              </form>

              {this.GridFull(store.getState().relContasPagarGeral.gridsForn)}
            </div>

            <div className="input-field colinput-field col s20">
                <div id="modal_legenda" class="modal modal-fixed-footer">
                  <div class="modal-content">
                    <h4>Legenda</h4>
                    <div className="row">
                      <i class="material-icons  green-text text-lighten-2 left">bookmark</i>Pago no prazo
                    </div>
                    <div class="row">
                      <i class="material-icons  green-text text-darken-4 left">bookmark</i>Paga em atraso
                    </div>
                    <div class="row">
                      <i class="material-icons  red-text text-darken-4 left">bookmark</i>Conta atrasada
                    </div>
                    <div class="row">
                      <i class="material-icons  orange-text left">bookmark</i>Vencimento para hoje
                    </div>
                    <div class="row">
                      <i class="material-icons  yellow-text left">bookmark</i> Conta à Pagar
                    </div>

                  </div>
                  <div class="modal-footer">
                    <a href="#!" class="modal-action modal-close waves-effect waves-green btn-flat ">Ok</a>
                  </div>
                </div>
                <button class="btn waves-effect waves-light modal-trigger" href="#!" data-target="modal_legenda">
                  <i class="material-icons  white-text left">bookmark</i> Legenda
                </button>
              </div>
          </div>
        </div>
      </div>

    );

  }
}
export default (RelatorioContasPagarFornecedores);
